import { PAGE_RESOURCES_STRATEGY_VS_HOOK } from '@unifyapps/carbon/no-code/components/page/InterfacePageResourceLoader/constants/resourceStrategyVsHook';
import { useInterfaceResourceStrategy } from '@unifyapps/carbon/no-code/context/InterfaceResourceStrategyProvider';
import type { InterfaceComponent } from '@unifyapps/carbon/no-code/types/interfaceComponent';
import { matrixClient, matrixMode } from '../constants';

export function usePageResourceLoading({
  interfaceId,
  interfaceComponent,
  locale,
  disableAuth,
}: {
  interfaceId: string;
  interfaceComponent: InterfaceComponent;
  locale?: string;
  disableAuth?: boolean;
}) {
  const { strategy } = useInterfaceResourceStrategy();
  const useResourceStrategy = PAGE_RESOURCES_STRATEGY_VS_HOOK[strategy];

  return useResourceStrategy({
    interfaceId,
    interfaceComponent,
    client: matrixClient,
    mode: matrixMode,
    locale,
    disableAuth,
  });
}
